import { PromotionDebugMode } from '@/stores/debug';

export interface PromotionDebugRequestConfig {
  shouldFetchActiveActivity: boolean;
  shouldFetchAtmosphereWidgets: boolean;
}

export function getPromotionDebugRequestConfig(debugMode: PromotionDebugMode): PromotionDebugRequestConfig {
  switch (debugMode) {
    case PromotionDebugMode.Disabled:
      return {
        shouldFetchActiveActivity: false,
        shouldFetchAtmosphereWidgets: false,
      };
    case PromotionDebugMode.AtmosphereOnly:
      return {
        shouldFetchActiveActivity: false,
        shouldFetchAtmosphereWidgets: true,
      };
    case PromotionDebugMode.ActivityOnly:
      return {
        shouldFetchActiveActivity: true,
        shouldFetchAtmosphereWidgets: false,
      };
    case PromotionDebugMode.Normal:
    default:
      return {
        shouldFetchActiveActivity: true,
        shouldFetchAtmosphereWidgets: false,
      };
  }
}
